import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import avatecLogo from '../../assets/logos/avatec-white.png';
import './Slide08Automation.css';

const experienceRows = [
  { label: '5+ years', value: 11, width: 69 },
  { label: '3+ years', value: 16, width: 100 },
  { label: '1+ years', value: 13, width: 81 },
];

function Slide08Automation() {
  const prefersReduced = useReducedMotion();
  const reduceMotion = !!prefersReduced;
  const [isVisible, setIsVisible] = useState(false);
  const ease: [number, number, number, number] = [0.25, 0.46, 0.45, 0.94];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const fadeUp = (delay = 0) =>
    reduceMotion
      ? { initial: { opacity: 1 }, animate: { opacity: 1 } }
      : {
          initial: { opacity: 0, y: 20 },
          animate: isVisible ? { opacity: 1, y: 0 } : {},
          transition: { duration: 0.7, delay, ease },
        };

  return (
    <div className="slide slide-automation">
      <img src={avatecLogo} alt="Avatec Marine" className="slide-logo" />

      <div className="automation-bg">
        <div className="automation-grid" />
        <div className="automation-lines" />
        <div className="automation-noise" />
      </div>

      <div className="automation-content">
        <motion.h1 className="automation-title" {...fadeUp(0.05)}>
          Automation Department
        </motion.h1>

        <div className="automation-grid-layout">
          <motion.div className="automation-card automation-card-hero" {...fadeUp(0.15)}>
            <div className="automation-card-label">MORE THAN</div>
            <div className="automation-card-value">40+</div>
            <div className="automation-card-sub">Automation Engineers</div>
          </motion.div>

          <motion.div className="automation-card automation-card-profile" {...fadeUp(0.2)}>
            <div className="automation-card-label">EXPERIENCE PROFILE</div>
            <div className="automation-profile-list">
              {experienceRows.map((row, index) => (
                <div key={row.label} className="automation-profile-row">
                  <div className="automation-profile-top">
                    <span>{row.label}</span>
                    <span>{row.value}</span>
                  </div>
                  <div className="automation-profile-track">
                    <motion.span
                      className="automation-profile-fill"
                      style={{ width: `${row.width}%` }}
                      initial={{ scaleX: reduceMotion ? 1 : 0 }}
                      animate={{ scaleX: 1 }}
                      transition={{ duration: 0.8, delay: 0.25 + index * 0.1, ease }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.p className="automation-lead" {...fadeUp(0.25)}>
            Avatec Marine provides advanced marine automation solutions for vessels of all types, delivering control,
            monitoring, and power management integrations for safe and efficient operations.
          </motion.p>

          <motion.div className="automation-card automation-card-list" {...fadeUp(0.3)}>
            <ul className="automation-list">
              <li>Boiler and IGG services</li>
              <li>Fire alarm and gas detection systems</li>
              <li>Power management systems</li>
              <li>Alarm monitoring systems</li>
              <li>Onboard automation upgrades for both newbuilding and retrofit projects</li>
            </ul>
          </motion.div>

          <motion.div className="automation-card automation-card-resp" {...fadeUp(0.35)}>
            <div className="automation-card-label">TEAM RESPONSIBILITY</div>
            <p className="automation-card-text">
              The Automation Team is responsible for system design, integration, commissioning, and lifecycle support
              of vessel automation systems, ensuring compliance with international regulations.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Slide08Automation;
